<template>
  <footer class="footer container">
    <div class="columns">
      <div class="content column">
        &copy; {{ new Date().getFullYear() }} Salt Creek Civil War Round Table
      </div>

      <div class="content column">
        <template v-for="item in navItems">
          <span :key="item.text">
            <router-link :to="{ name: item.link, params: { id: item.path } }">
              {{ item.text }}
            </router-link>
            <br>
          </span>
        </template>
      </div>
    </div>
  </footer>
</template>

<script>
import { START_ITEMS, END_ITEMS, } from '@/helpers/nav_items';

export default {
  name: 'TheFooter',
  data() {
    return {
      navItems: [...START_ITEMS, ...END_ITEMS,],
    };
  },
};
</script>

<style scoped>
footer {
  box-shadow: 0 50vh 0 50vh hsl(0, 0%, 98%);
}
</style>
